module.exports = __webpack_public_path__ + "img/xiaozhan.d47942b4.png";